/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1ClassroomdisciplineIdUsersPersonidGrade202,
  PatchApiV1ClassroomdisciplineIdUsersPersonidGrade400,
  PatchApiV1ClassroomdisciplineIdUsersPersonidGrade401,
  PatchApiV1ClassroomdisciplineIdUsersPersonidGrade404,
  PatchApiV1ClassroomdisciplineIdUsersPersonidGradeMutationRequest,
  PatchApiV1ClassroomdisciplineIdUsersPersonidGradeMutationResponse,
  PatchApiV1ClassroomdisciplineIdUsersPersonidGradePathParams,
} from "../../types/classPlanningPeopleController/PatchApiV1ClassroomdisciplineIdUsersPersonidGrade.ts";
import { modifyGradeRequestViewModelSchema } from "../modifyGradeRequestViewModelSchema.ts";

export const patchApiV1ClassroomdisciplineIdUsersPersonidGradePathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    personId: z.coerce.number().int(),
  }) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersPersonidGradePathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const patchApiV1ClassroomdisciplineIdUsersPersonidGrade202Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersPersonidGrade202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const patchApiV1ClassroomdisciplineIdUsersPersonidGrade400Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersPersonidGrade400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1ClassroomdisciplineIdUsersPersonidGrade401Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersPersonidGrade401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const patchApiV1ClassroomdisciplineIdUsersPersonidGrade404Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersPersonidGrade404>;

export const patchApiV1ClassroomdisciplineIdUsersPersonidGradeMutationRequestSchema =
  z.lazy(
    () => modifyGradeRequestViewModelSchema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersPersonidGradeMutationRequest>;

export const patchApiV1ClassroomdisciplineIdUsersPersonidGradeMutationResponseSchema =
  z.lazy(
    () => patchApiV1ClassroomdisciplineIdUsersPersonidGrade202Schema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdUsersPersonidGradeMutationResponse>;
